/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopAppliedFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user">;
    readonly " $refType": "SbRespRefineTopAppliedFilters_user";
};
export type SbRespRefineTopAppliedFilters_user$data = SbRespRefineTopAppliedFilters_user;
export type SbRespRefineTopAppliedFilters_user$key = {
    readonly " $data"?: SbRespRefineTopAppliedFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopAppliedFilters_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineTopAppliedFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "measurementUnit",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '621345bc73e2beb83b46f384c1d397a9';
export default node;
